module.exports = __webpack_public_path__ + "static/media/chartCircle.948b5817.svg";